module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/penn-state-4e8134bb4133f529e23a63a56356dacc.svg";